import { RootState } from '../rootReducer';
import { SubscriptionState } from './customer';

export const selectSubscription = (state: RootState): SubscriptionState => state.subscription;
export const selectSubscriptionUpdatingState = (state: RootState): boolean => selectSubscription(state).updatingSubscription;
